import React from "react";
import "./About.css";
import ReduxIcon from "../assets/redux.png";
import HTML from "../assets/html.png";
import Flutter from "../assets/flutter.png";
import VSCode from "../assets/vscode.png";
import Figma from "../assets/figma.png";
import ReactIcon from "../assets/react.png";
import npm from "../assets/npm.png";
import GitLogo from "../assets/git.png";
import GitHublogo from "../assets/github.png";
import Canva from "../assets/canva.png";
import CSS from "../assets/css.png";
import BootStrap from "../assets/bootstrap.png";
import JavaScript from "../assets/javascript.png";
import Sass from "../assets/sass.png";
import Angular from "../assets/angular.png";
import Tailwind from "../assets/tailwind.png";
import Vite from "../assets/vite.png";
import Node from "../assets/Node.js.png";
import Express from "../assets/express.png";
import SpringBoot from "../assets/spring.png";
import MongoDB from "../assets/mongo.png";
import MySQL from "../assets/mysql.png";
import Atom from "../assets/atom.png";
import Jenkins from "../assets/jenkins.png";
import Docker from "../assets/docker.png";
import Nginx from "../assets/nginx.png";
import Kuber from "../assets/kuber.png";
import Terraform from "../assets/terra.png";
import XD from "../assets/xd.png";
import TF from "../assets/tf.png";
import Keras from "../assets/keras.png";
import Scikit from "../assets/sl.png";
import CV from "../assets/cv.png";
import AI from "../assets/ai.png";
import Hiber from "../assets/hiber.png";
import Ansible from "../assets/ansible.png";
import C from "../assets/c.png";
import cpp from "../assets/cpp.png";
import java from "../assets/java.png";
import py from "../assets/py.png";
import sql from "../assets/sql.png";
import dart from "../assets/dart.png";
import r from "../assets/r.png";
import AWS from "../assets/aws.png";
import bash from "../assets/bash.png";
import act from "../assets/act.png";
import linux from "../assets/linux.png";
import kot from "../assets/kot.png";

const About = () => (
  <section className="about" id="about">
    <div className="about-me">
      <h2 className="title about-title">About Me</h2>
      <p className="paragraph about-para">
        I'm Sriragavi, a passionate computer science engineering student with a
        focus on machine learning, deep learning, artificial intelligence, and
        web development. I have a strong command of programming languages like
        C, C++, Java, JavaScript, and Python, which I utilize to build robust
        and efficient applications. I am skilled in frontend development using
        React.js and have expertise in backend development using Node.js. I have
        hands-on experience with databases like MongoDB for efficient data
        storage and retrieval. Additionally, I am proficient in using Figma for
        UI/UX design and have knowledge of working with open APIs. With a
        constant thirst for knowledge, I actively participate in hackathons and
        workshops to enhance my skills.
      </p>
      <button className="hire-me">
        <a
          href="https://drive.google.com/file/d/1oQwK5SEXOvvue2XDNYEz500tClrvFCaY/view?usp=sharing"
          target="_blank"
          rel="noreferrer"
        >
          Get My Resume
        </a>
      </button>
    </div>
    <div className="about-skills">
      <br></br>
      <h2 className="skill-title">Front-End</h2>
      <div className="skills">
        <div className="skill">
          <img src={HTML} alt="" />
        </div>
        <div className="skill">
          <img src={CSS} alt="" />
        </div>
        <div className="skill">
          <img src={JavaScript} alt="" />
        </div>
        <div className="skill">
          <img src={Sass} alt="" />
        </div>
        <div className="skill">
          <img src={Tailwind} alt="" />
        </div>
        <div className="skill">
          <img src={Vite} alt="" />
        </div>
        <div className="skill">
          <img src={BootStrap} alt="" />
        </div>
        <div className="skill">
          <img src={ReduxIcon} alt="" />
        </div>
        <div className="skill">
          <img src={ReactIcon} alt="" />
        </div>
        <div className="skill">
          <img src={Angular} alt="" />
        </div>
      </div>
      <h2 className="skill-title">Back-End</h2>
      <div className="skills">
        <div className="skill">
          <img src={Node} alt="" />
        </div>
        <div className="skill">
          <img src={Express} alt="" />
        </div>
        <div className="skill">
          <img src={SpringBoot} alt="" />
        </div>
        <div className="skill">
          <img src={linux} alt="" />
        </div>
      </div>
      <h2 className="skill-title">DataBases</h2>
      <div className="skills">
        <div className="skill">
          <img src={MongoDB} alt="" />
        </div>
        <div className="skill">
          <img src={MySQL} alt="" />
        </div>
        <div className="skill">
          <img src={Hiber} alt="" />
        </div>
      </div>
      <h2 className="skill-title">Mobile</h2>
      <div className="skills">
        <div className="skill">
          <img src={Flutter} alt="" />
        </div>
        <div className="skill">
          <img src={ReactIcon} alt="" />
        </div>
      </div>
      <h2 className="skill-title">ML / DL </h2>
      <div className="skills">
        <div className="skill">
          <img src={TF} alt="" />
        </div>
        <div className="skill">
          <img src={Keras} alt="" />
        </div>
        <div className="skill">
          <img src={AI} alt="" />
        </div>
        <div className="skill">
          <img src={Scikit} alt="" />
        </div>
        <div className="skill">
          <img src={CV} alt="" />
        </div>
      </div>
      <h2 className="skill-title">Tools</h2>
      <div className="skills">
        <div className="skill">
          <img src={GitLogo} alt="" />
        </div>
        <div className="skill">
          <img src={GitHublogo} alt="" />
        </div>
        <div className="skill">
          <img src={AWS} alt="" />
        </div>
        <div className="skill">
          <img src={VSCode} alt="" />
        </div>
        <div className="skill">
          <img src={Atom} alt="" />
        </div>
        <div className="skill">
          <img src={Ansible} alt="" />
        </div>
        <div className="skill">
          <img src={Jenkins} alt="" />
        </div>
        <div className="skill">
          <img src={Docker} alt="" />
        </div>
        <div className="skill">
          <img src={Nginx} alt="" />
        </div>
        <div className="skill">
          <img src={Kuber} alt="" />
        </div>
        <div className="skill">
          <img src={Terraform} alt="" />
        </div>
        <div className="skill">
          <img src={npm} alt="" />
        </div>
        <div className="skill">
          <img src={bash} alt="" />
        </div>
        <div className="skill">
          <img src={act} alt="" />
        </div>
      </div>
      <h2 className="skill-title">Design</h2>
      <div className="skills">
        <div className="skill">
          <img src={Figma} alt="" />
        </div>
        <div className="skill">
          <img src={XD} alt="" />
        </div>
        <div className="skill">
          <img src={Canva} alt="" />
        </div>
      </div>
      <h2 className="skill-title">Programming Languages</h2>
      <div className="skills">
        <div className="skill">
          <img src={C} alt="" />
        </div>
        <div className="skill">
          <img src={cpp} alt="" />
        </div>
        <div className="skill">
          <img src={java} alt="" />
        </div>
        <div className="skill">
          <img src={py} alt="" />
        </div>
        <div className="skill">
          <img src={sql} alt="" />
        </div>
        <div className="skill">
          <img src={dart} alt="" />
        </div>
        <div className="skill">
          <img src={r} alt="" />
        </div>
        <div className="skill">
          <img src={kot} alt="" />
        </div>
      </div>
    </div>
  </section>
);

export default About;
